import React, { Component } from 'react';
import {TRIGGER_SAMPLE, RELEASE_SAMPLE} from 'constants/event-types.js';
import { Rect } from 'react-konva';
import Tone from 'tone';

const PLAY_UPDATE_RATE = 80;
const MAX_TICKS = 10;

class PlayTick extends Component {
    constructor(props) {
        super(props);

        this.state = {
            playTicks: {},
        };
        this.onTriggerSample = this.onTriggerSample.bind(this);
        this.onReleaseSample = this.onReleaseSample.bind(this);
    }

    componentDidMount() {
        window.addEventListener(TRIGGER_SAMPLE, this.onTriggerSample);
        window.addEventListener(RELEASE_SAMPLE, this.onReleaseSample);
    }

    componentWillUnmount() {
        window.removeEventListener(TRIGGER_SAMPLE, this.onTriggerSample);
        window.removeEventListener(RELEASE_SAMPLE, this.onReleaseSample);
    }

    onReleaseSample(time) {
        setTimeout(() => {
            Object.keys(this.state.playTicks).forEach(
                x => clearInterval(x));
            this.setState({playTicks: {}});
        }, time);
    }

    onTriggerSample(event) {
        if (event.soundId !== this.props.soundId) {
            return;
        }
        if (Object.keys(this.state.playTicks).length >= MAX_TICKS) {
            // we don't want to overload
            return;
        }

        let time = event.time;
        let transpose = event.transpose;
        let multiple = Math.pow(2, (transpose / 12));
        setTimeout(() => {
            let timeSince = 0;
            let startTime = new Date().getTime()
            let timer = setInterval(() => {
                let currentTime = new Date().getTime();
                timeSince = (currentTime - startTime) / 1000.0;
                let playTicks = this.state.playTicks;
                let elapsed = timeSince * multiple;
                if (this.props.instrument && this.props.instrument.loop) {
                    if (this.props.instrument.defaultSampler === undefined) {
                        return;
                    }
                    let loopLength = this.props.instrument.defaultSampler.getDuration() *
                        this.props.instrument.loopLength / 100.0;
                    elapsed = elapsed % loopLength;
                }
                let secs = event.startTime + elapsed;
                playTicks[timer] = this.props.convertSecondsToSpace(secs);
                if (event.duration && timeSince > event.duration) {
                    clearInterval(timer);
                    delete playTicks[timer];
                }
                this.setState(this.state);
            }, PLAY_UPDATE_RATE);
            let x = this.props.convertSecondsToSpace(event.startTime);
            let playTicks = this.state.playTicks;
            playTicks[timer] = x;
            this.setState(this.state);
        }, time);
    }

    render() {
        return Object.values(this.state.playTicks)
            .map(x =>
                 <Rect
                 x={x}
                 y={0}
                 width={2}
                 height={this.props.height}
                 fill='rgb(35, 249, 111)'/>)
    }
}

export default PlayTick;
